// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3mZh5","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2R8t0","gfeWrapper":"CalendarEvent_gfeWrapper__3pU-B"};